import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";
import commonEN from "./translations/en/common.json";
import formEN from "./translations/en/form.json";
import validationEN from "./translations/en/validation.json";
import commonNL from "./translations/nl/common.json";
import formNL from "./translations/nl/form.json";
import validationNL from "./translations/nl/validation.json";
import commonDE from "./translations/de/common.json";
import formDE from "./translations/de/form.json";
import validationDE from "./translations/de/validation.json";
import modulesEN from "./translations/en/modules.json";
import modulesNL from "./translations/nl/modules.json";
import modulesDE from "./translations/de/modules.json";
const resources = {
    en: {
        common: commonEN,
        form: formEN,
        validation: validationEN,
        modules: modulesEN,
    },
    nl: {
        common: commonNL,
        form: formNL,
        validation: validationNL,
        modules: modulesNL,
    },
    de: {
        common: commonDE,
        form: formDE,
        validation: validationDE,
        modules: modulesDE,
    },
};
i18n
    .use(XHR)
    .use(LngDetector)
    .use(initReactI18next)
    .init({
    resources,
    lng: "nl", // Force Dutch language
    fallbackLng: "nl",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
